import { render, staticRenderFns } from "./ProposalTableCustomer.vue?vue&type=template&id=0d7af88c&"
import script from "./ProposalTableCustomer.vue?vue&type=script&lang=js&"
export * from "./ProposalTableCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ProposalTableCustomer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports